var map = {
	"./en-us/auth.json": [
		3856,
		856
	],
	"./en-us/chat.json": [
		6916,
		916
	],
	"./en-us/common.json": [
		827,
		827
	],
	"./en-us/error.json": [
		7388,
		388
	],
	"./en-us/event.json": [
		8482,
		482
	],
	"./en-us/event_details.json": [
		5523,
		523
	],
	"./zh-tw/auth.json": [
		9750,
		750
	],
	"./zh-tw/chat.json": [
		3182,
		182
	],
	"./zh-tw/common.json": [
		6681,
		681
	],
	"./zh-tw/error.json": [
		3230,
		230
	],
	"./zh-tw/event.json": [
		4932,
		932
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2096;
module.exports = webpackAsyncContext;